const ajax = require('sma.common/ajax');
const Grid = require('sma.admin/components/grid');

const cardTempl = require('sma.applicant/programs/partials/card.mustache');
const paginationBtns = require('sma.applicant/components/partials/pagination.mustache');
const applicationDropdownTempl = require('sma.applicant/programs/partials/applications.mustache');

let VIEWS = {
	GRID: 0,
	LIST: 1,
};

const STRINGS = {
	applicationLocked: gettext('Application is locked'),
	more: gettext('MORE'),
	of: gettext('of'),
	choose_app: gettext('Choose application:'),
	programs: gettext('Programs'),
	deadline: gettext('Deadline'),
	applications: gettext('Applications'),
	see_application: gettext('See my application'),
	program: gettext('Program'),
	award_value: gettext('Award value'),
	open_date: gettext('Open date'),
	no_programs: gettext('Sorry, there are no programs'),
	not_eligible: gettext('Sorry, you are not eligible for this program'),
	next: gettext('Next'),
	previous: gettext('Previous'),
};

class ProgramListView extends Backbone.View {
	get events() {
		return {
			'click .sma-js-grid-view': 'setGridView',
			'click .sma-js-list-view': 'setListView',
			'keyup #sma-js-dashboard-search': 'search',
			'click .sma-js-dashboard-prev': 'previousPage',
			'click .sma-js-dashboard-next': 'nextPage',
			'click #sma-js-programs-filter a.dropdown-item': 'filter',
		};
	}

	get $programList() {
		return $('.sma-js-program-list');
	}

	get $programGrid() {
		return $('.sma-js-program-grid');
	}

	get $pagination() {
		return $('.sma-js-dashboard-pagination');
	}

	set VIEW(v) {
		localStorage.setItem('applicantProgramsView', v);
	}

	get VIEW() {
		const viewStored = parseInt(localStorage.getItem('applicantProgramsView'));
		return _.values(VIEWS).indexOf(viewStored) != -1 ? viewStored : VIEWS.GRID;
	}


	constructor(config) {
		super();

		this.setElement($('body'));
		this.eligibility_completed = config.eligibility_completed;
		this.params = {
			page: 1,
			base_query: this.eligibility_completed ? 'eligible' : 'all',
		};
		this.load();
	}

	load() {
		let url = reverse('program-list-datasource')+'?'+$.param(this.params);

		ajax.get({
			url: url,
			loaderElement: $('.sma-js-application-grid-container'),
			loaderSize: 'lg',
			callback: (response) => {
				this.programs = response.results;
				this.count = response.program_count;
				this.next = response.has_next;
				this.previous = response.has_previous;
				this.render();
			},
		});
	}

	render(context) {
		this.$programGrid.empty();

		if (this.programs.filter(program => (program.value)).length === 0) {
			columns = columns.filter(column => (column.id !== 'value'));
		}

		let url = reverse('program-list-datasource');

		new ProgramGrid({
			element: this.$programList,
			columns: columns,
			url: url,
			extraData: this.params,
			results: {
				count: this.count,
				results: this.programs,
			},
		});

		for (var program of this.programs) {
			let applicationsDropdown = applicationDropdownTempl({
				program: program,
				strings: STRINGS,
			});

			this.$programGrid.append(cardTempl({
				program: program,
				strings: STRINGS,
				applicationsDropdown: applicationsDropdown
			}));
		}

		if (this.programs.length === 0) {
			this.$programGrid.append(`<div class="col-12"><div class="sma-placeholder-text text-sm-center"><h3>${STRINGS.no_programs}</h3></div></div>`);
		}

		this.renderPagination();

		// set the views once the program grid exists, not before
		if (this.VIEW === VIEWS.GRID) {
			this.setGridView();
		} else {
			this.setListView();
		}
	}

	renderPagination() {
		if (this.programs.length === 0) {
			this.$pagination.empty();
			return;
		}

		let lbound = ((this.params.page - 1) * 10);
		let ubound = lbound + this.programs.length;

		this.$pagination.html($(paginationBtns({
			next: this.next,
			previous: this.previous,
			strings: STRINGS,
			text: `${lbound+1} - ${ubound} ${STRINGS.of} ${this.count} ${STRINGS.programs}`,
		})));
	}

	setGridView() {
		this.VIEW = VIEWS.GRID;
		this.$programGrid.show();
		this.$programList.hide();
		$('.sma-js-grid-view').addClass('sma-dashboard-toggle-active');
		$('.sma-js-list-view').removeClass('sma-dashboard-toggle-active');
	}

	setListView() {
		this.VIEW = VIEWS.LIST;
		this.$programGrid.hide();
		this.$programList.show();
		$('.sma-js-grid-view').removeClass('sma-dashboard-toggle-active');
		$('.sma-js-list-view').addClass('sma-dashboard-toggle-active');
	}

	search(e) {
		if (e.keyCode === 13) {
			this.params.search = $(e.target).val();
			this.params.page = 1;
			this.load();
		}
	}

	filter(e) {
		e.preventDefault();

		let val = $(e.target).attr('href');

		$('#sma-js-programs-filter-label').text($(e.target).text());

		this.params.base_query = val;
		this.params.page = 1;
		this.load();
	}

	previousPage(e) {
		e.preventDefault();
		if (this.params.page == 1) return;
		this.params.page = this.params.page - 1;
		this.load();
	}

	nextPage(e) {
		e.preventDefault();
		this.params.page = this.params.page + 1;
		this.load();
	}
}


let columns = [
	{
		id: 'name',
		name: STRINGS.program,
		sortable: true,
	}, {
		id: 'value',
		name: STRINGS.award_value,
		sortable: true,
	}, {
		id: 'startdate',
		name: STRINGS.open_date,
		sortable: true,
	}, {
		id: 'deadline',
		name: STRINGS.deadline,
		sortable: true,
	}, {
		id: 'applications',
		name: '',
		formatter: function(item, grid) {
			return applicationDropdownTempl({
				program: item,
				strings: STRINGS,
			});
		}
	}, {
		id: 'menu',
		name: '',
		formatter: function(item, grid) {
			return `<a href="${item.listing_url}" class="sma-program-more">
					${STRINGS.more} <i class="nc-icon-mini arrows-1_minimal-right" aria-hidden="true"></i>
				</a>`;
		}
	}
];

let ProgramGrid = Grid.Grid.extend({
	showTitlebar: false,
	showToolbar: false,
	showSearchBar: false,
	showFooter: false,
	showSelectorColumn: false,
	showColumnDropSelect: false,
});

module.exports = {
	ProgramListView: ProgramListView
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/programs/list.js